import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CreditCard, Receipt, Tag, RefreshCw } from 'lucide-react';
import { PricingSettings } from './PricingSettings';
import { CheckoutSettings } from './CheckoutSettings';
import { CreditPurchasesLog } from './CreditPurchasesLog';
import { CreditTransactionsLog } from './CreditTransactionsLog';
import { StripePriceSync } from './StripePriceSync';

export function BillingManager() {
  return (
    <Tabs defaultValue="pricing" className="space-y-6">
      <div className="rounded-xl border border-border/60 bg-card p-1.5">
        <TabsList className="grid w-full grid-cols-2 md:grid-cols-4 h-auto bg-transparent gap-1 p-0">
          <TabsTrigger value="pricing" className="gap-2">
            <Tag className="h-4 w-4" />
            <span className="hidden sm:inline">Pricing</span>
          </TabsTrigger>
          <TabsTrigger value="checkout" className="gap-2">
            <CreditCard className="h-4 w-4" />
            <span className="hidden sm:inline">Checkout</span>
          </TabsTrigger>
          <TabsTrigger value="credits-log" className="gap-2">
            <Receipt className="h-4 w-4" />
            <span className="hidden sm:inline">Credits Log</span>
          </TabsTrigger>
          <TabsTrigger value="stripe-sync" className="gap-2">
            <RefreshCw className="h-4 w-4" />
            <span className="hidden sm:inline">Stripe Sync</span>
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="pricing" className="mt-0"><PricingSettings /></TabsContent>
      <TabsContent value="checkout" className="mt-0"><CheckoutSettings /></TabsContent>
      <TabsContent value="credits-log" className="mt-0 space-y-6">
        <CreditPurchasesLog />
        <CreditTransactionsLog />
      </TabsContent>
      <TabsContent value="stripe-sync" className="mt-0"><StripePriceSync /></TabsContent>
    </Tabs>
  );
}
